import { Injectable, OnInit } from '@angular/core';

@Injectable()
export class CodiceFiscaleService implements OnInit {
    private regexCF = new RegExp(/^(?:[B-DF-HJ-NP-TV-Z](?:[AEIOU]{2}|[AEIOU]X)|[AEIOU]{2}X|[B-DF-HJ-NP-TV-Z]{2}[A-Z]){2}[\dLMNP-V]{2}(?:[A-EHLMPR-T](?:[04LQ][1-9MNP-V]|[1256LMRS][\dLMNP-V])|[DHPS][37PT][0L]|[ACELMRT][37PT][01LM])(?:[A-MZ][1-9MNP-V][\dLMNP-V]{2}|[A-M][0L](?:[\dLMNP-V][1-9MNP-V]|[1-9MNP-V][0L]))[A-Z]$/i)
    private vowels = new RegExp(/[AEIOU]/);
    private consonants = new RegExp(/[B-DF-HJ-NP-TV-Z]/);
    private Months = ['A', 'B', 'C', 'D', 'E', 'H', 'L', 'M', 'P', 'R', 'S', 'T']
    private cfGenerated = { _nome: "", _cognome: "", _anno: "", _mese: "", _giorno: "", _sesso: "", _luogoDiNascita: "", _controllore: "" }

    constructor(
    ) { }
    ngOnInit() { }
    public isValidCF(codiceFiscale): boolean {
        return this.regexCF.test(codiceFiscale)
    }
    public getCFGenerated() {
        return this.cfGenerated;
    }
    public generateCF(nome?, cognome?, anno?, mese?, giorno?, sesso?, luogoDiNascita?) {
            var CalculatedFC = "";
            if (nome && cognome && anno && mese && giorno && sesso && luogoDiNascita) {
                var CalculatedFC = ""
                this.GCognome(cognome);
                this.GNome(nome);
                this.GAnno(anno);
                this.GMese(mese);
                this.GGiorno(giorno, sesso);
                this.FindLuogoDiNascitaCodice(
                    (CodiceLuogoDiNascita) => {
                        CalculatedFC = cognome + nome + anno + mese + giorno + CodiceLuogoDiNascita;
                        return { 'cf': CalculatedFC, 'error': null };
                    },
                    (error) => {
                        return { 'cf': null, 'error': error };
                    }, "ITA", luogoDiNascita)
            } else {
                const { _cognome, _nome, _anno, _mese, _giorno, _luogoDiNascita } = this.cfGenerated;
                CalculatedFC = _cognome + _nome + _anno + _mese + _giorno + _luogoDiNascita
                if (_cognome && _nome && _anno && _mese && _giorno && _luogoDiNascita) {
                    return { 'cf': CalculatedFC, 'error': null };
                } else {
                    return { 'cf': null, 'error': "Le informazioni da produrre 'generare' Codice Fiscale sono Insufficienti " + CalculatedFC };
                }
            }
    }


    public GCognome(cognome: string) {
        cognome = cognome.toUpperCase();
        if (this.cfGenerated._cognome != cognome) this.cfGenerated._cognome = ""; else return
        var index = 0;
        for (var char of cognome)
            if (index < 3 && this.consonants.test(char)) {
                this.cfGenerated._cognome += char;
                index++
            }
        if (index < 3) {
            for (var char of cognome)
                if (index < 3 && this.vowels.test(char)) { this.cfGenerated._cognome += char; index++; }
            if (index < 3)
                while (index < 3) { this.cfGenerated._cognome += "X"; index++; }
        }
    }
    public GNome(nome: string) {
       // console.log("GNome",nome)
        nome = nome.toUpperCase();
        if (this.cfGenerated._nome != nome) this.cfGenerated._nome = ""; else return
        var index = 0;
        for (var char of nome)
            if (index < 4 && this.consonants.test(char)) { this.cfGenerated._nome += char; index++ }

        if (index > 3) {
            this.cfGenerated._nome = this.cfGenerated._nome[0] + this.cfGenerated._nome[2] + this.cfGenerated._nome[3];
        } else {
            if (index < 3) {
                for (var char of nome)
                    if (index < 3 && this.vowels.test(char)) { this.cfGenerated._nome += char; index++ }
                if (index < 3)
                    while (index < 3) { this.cfGenerated._nome += "X"; index++; }
            }
        }
        //console.log("GNome",this.cfGenerated._nome)
    }

    public GAnno(year: number) {
        if (this.cfGenerated._anno != year + "") this.cfGenerated._anno = ""; else return
        var y = (year % 100)
        this.cfGenerated._anno = y > 9 ? y + "" : "0" + y;
    }
    public GMese(month: number) {
        if (this.cfGenerated._mese != month + "") this.cfGenerated._mese = ""; else return
        this.cfGenerated._mese = this.Months[month - 1];
    }
    public GGiorno(giorno, gender: string) {
        if (!gender) return;
        var day = Number(giorno) + ""
        var d = Number(day);
        if (this.cfGenerated._giorno != day + "") this.cfGenerated._giorno = ""; else return
        this.cfGenerated._giorno = (gender == "M") ? (d > 9 ? day : "0" + day) : (d + 40) + "";
    }
    public GLuogoDiNascita(ldn: string) {
        this.cfGenerated._luogoDiNascita = ldn
    }
    public FindLuogoDiNascitaCodice(resolve, reject, nazionalita: string, ldn: string, list?: Array<any>, ItalianCities?: Array<any>) {
        if (nazionalita != 'ITA') {
            if (!list) {
                reject("send me the list of countries wit thier codes")
            } else {
                let place = list.find(country => country.description.toUpperCase() == ldn.toUpperCase());
                if (place) {
                    let cfCode = place.cfCode;
                    resolve(cfCode)
                }
            }
        } else {
            for (var city of ItalianCities) {
                if (city.description == ldn)
                    resolve(city.cfCode);
            }
            reject("Luogo di Nascità non trovato !");
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/theme/services/codiceFiscale.service.ts